import { locales } from '@shared/constants/localization/LocalizationConstants';
import { DefaultClient, DefaultDeviceType } from '@shared/constants/organization/ProjectDefaults';
import { CustomControlsModel } from '@shared/models/devices/CustomControlsModel';
import DeviceTypeClientListingModel from '@shared/models/devices/DeviceTypeClientListingModel';
import UpdateDeviceTypeClientListingModel from '@shared/models/devices/UpdateDeviceTypeClientListingModel';
import OrganizationAuthClientModel from '@shared/models/organizations/OrganizationAuthClientModel';
import OrganizationDeviceTypeModel from '@shared/models/organizations/OrganizationDeviceTypeModel';

export const getDefaultDeviceType = (organizationId?: string): OrganizationDeviceTypeModel => {
    return {
        ...DefaultDeviceType,
        organizationId,
    };
};

export const getDefaultClient = (organizationId: string): OrganizationAuthClientModel => {
    return {
        ...DefaultClient,
        organizationId,
    };
};

export const convertDeviceTypeClientListingToUpdateRequest = (
    listing: DeviceTypeClientListingModel[]
): UpdateDeviceTypeClientListingModel[] => {
    if (!listing) return [];
    return listing.map(({ createdDate, updatedDate, deviceTypeId, priority, isPublic, ...rest }) => rest);
};

export const ensureAllLocalesExistInClientListing = (
    listing: DeviceTypeClientListingModel[]
): DeviceTypeClientListingModel[] => {
    const updatedListing = [...listing];
    const iconLight = listing.find((l) => l.locale === 'en')?.iconUrl || '';
    const darkModeIconUrl = listing.find((l) => l.locale === 'en')?.darkModeIconUrl || '';
    locales.display.forEach((locale) => {
        if (!updatedListing.find((l) => l.locale === locale)) {
            updatedListing.push({
                locale,
                markdownDescription: '',
                markdownOnboardingInstructions: '',
                markdownTroubleshootingInstructions: '',
                title: '',
                shortDescription: '',
                iconUrl: iconLight,
                darkModeIconUrl: darkModeIconUrl,
            } as DeviceTypeClientListingModel);
        }
    });
    return updatedListing;
};

export const ensureAllLocalesExistInCustomControls = (
    customControls: CustomControlsModel[],
    deviceTypeId?: string
): CustomControlsModel[] => {
    const updated = [...customControls];
    const baseEntry = customControls.find((c) => c.locale === 'en') ?? customControls[0];
    locales.display.forEach((locale) => {
        if (!updated.find((c) => c.locale === locale)) {
            updated.push({
                id: '',
                createdDate: new Date(),
                modifiedDate: new Date(),
                locale,
                deviceTypeId: deviceTypeId ?? baseEntry?.deviceTypeId,
                controls: baseEntry ? baseEntry.controls.map((control) => ({ ...control })) : [],
            });
        }
    });
    return updated;
};
